import { ReactElement } from 'react'
import { SnackbarKey, useSnackbar } from 'notistack'
import { Button } from '@mui/material'

interface Props {
  snackbarKey: SnackbarKey
}

// Uses the context-scoped closeSnackbar from useSnackbar() rather than the
// module-level import, so it closes the snackbar on whichever provider actually
// owns it. With multiple mounted SnackbarProviders the module-level closeSnackbar
// only targets the most recently mounted one.
const SnackbarCloseButton = ({ snackbarKey }: Props): ReactElement => {
  const { closeSnackbar } = useSnackbar()

  return (
    <Button variant="text" size="small" color="inherit" onClick={() => closeSnackbar(snackbarKey)}>
      OK
    </Button>
  )
}

export default SnackbarCloseButton
